import { useAxios } from "../axiosConfig";

const LeaveApi = () => {
    const axiosConfig = useAxios();

    const getLeaveCalendarEventList = async (month, year) => {
        try {
            const response = await axiosConfig.get(`/management/leave/calendarItem/list`,
                {
                    headers: {
                        'month': month,
                        'year': year
                    }
                }
            );
            return response;
        } catch (error) {
            throw error;
        }
    };

    const addLeave = async (data) => {
        try {
            const response = await axiosConfig.post('/management/leave',
                data,
            );
            return response;
        } catch (error) {
            throw error;
        }
    }

    const addLeaveRequest = async (data) => {
        try {
            const response = await axiosConfig.post('/management/leave-request',
                data,
            );
            return response;
        } catch (error) {
            throw error;
        }
    }

    const getLeaveTypeData = async (data) => {
        try {
            const response = await axiosConfig.post('/management/leaveType', data);
            return response;
        } catch (error) {
            throw error;
        }
    }

    const getLeaveList = async (data) => {
        try {
            const response = await axiosConfig.post('/management/get-list-leave', data);
            return response;
        } catch (error) {
            throw error;
        }
    }

    const getLeaveRequestList = async (data) => {
        try {
            const response = await axiosConfig.post('/management/get-list-leave-request', data);
            return response;
        } catch (error) {
            throw error;
        }
    }

    const getLeaveById = async (data) => {
        try {
            const response = await axiosConfig.post('/management/leave/detail', data);
            return response;
        } catch (error) {
            throw error;
        }
    }

    const deleteLeave = async (data) => {
        try {
            const response = await axiosConfig.post('/management/delete-leave', data);
            return response;
        } catch (error) {
            throw error;
        }
    }

    const deleteLeaveRequest = async (data) => {
        try {
            const response = await axiosConfig.post('/management/delete-leave-request', data);
            return response;
        } catch (error) {   
            throw error;
        }
    }

    const editLeave = async (data) => {
        try {
            const response = await axiosConfig.post('/management/edit-leave', data);
            return response;
        } catch (error) {
            throw error;
        }
    }

    const editLeaveRequest = async (data) => {
        try {
            const response = await axiosConfig.post('/management/edit-leave-request', data);
            return response;
        } catch (error) {
            throw error;
        }
    }

    const calendarLeave = async (data) => {
        try {
            const response = await axiosConfig.post('/management/calendar-leave', data);
            return response;
        } catch (error) {
            throw error;
        }
    }

    const calendarLeaveRequest = async (data) => {
        try {
            const response = await axiosConfig.post('/management/calendar-leave-request', data);
            return response;
        } catch (error) {
            throw error;
        }
    }

    const addLeaveType = async (data) => {
        try {
            const response = await axiosConfig.post('/management/add-leave-types',
                data,
            );
            return response;
        } catch (error) {
            throw error;
        }
    }

    const editLeaveType = async (data) => {
        try {
            const response = await axiosConfig.post('/management/edit-leave-types',
                data,
            );
            return response;
        } catch (error) {
            throw error;
        }
    }

    const deleteLeaveType = async (data) => {
        try {
            const response = await axiosConfig.post('/management/delete-leave-types',
                data,
            );
            return response;
        } catch (error) {
            throw error;
        }
    }

    const restoreLeaveType = async (data) => {
        try {
            const response = await axiosConfig.post('/management/restore-leave-types',
                data,
            );
            return response;
        } catch (error) {
            throw error;
        }
    }

    const getPoliciesList = async (data) => {
        try {
            const response = await axiosConfig.post('/management/get-list-policies', data);
            return response;
        } catch (error) {
            throw error;
        }
    }

    const chartLeave = async (data) => {
        try {
            const response = await axiosConfig.post('/management/chart-leave',
                data,
            );
            return response;
        } catch (error) {
            throw error;
        }
    }

    const chartLeaveRequest = async (data) => {
        try {
            const response = await axiosConfig.post('/management/chart-leave-request',
                data,
            );
            return response;
        } catch (error) {
            throw error;
        }
    }

    const updateLeaveRequestStatus = async (data) => {
        try {
            const response = await axiosConfig.post('/management/update-leave-request-status', data);
            return response;
        } catch (error) {
            throw error;
        }
    }

    const getLeaveRequestId = async (data) => {
        try {
            const response = await axiosConfig.post('/management/get-leave-request-id', data);
            return response;
        } catch (error) {
            throw error;
        }
    }

    const getLeaveRequestIdHistory = async (data) => {
        try {
            const response = await axiosConfig.post('/management/get-leave-request-id-history', data);
            return response;
        } catch (error) {
            throw error;
        }
    }

    const getLeaveSummaryUserList = async (data) => {
        try {
            const response = await axiosConfig.post(
                '/management/get-list-leave-summary-user',
                data
            );
            return response;
        } catch (error) {
            throw error;
        }
    }

    const getLeaveReportUserList = async (data) => {
        try {
            const response = await axiosConfig.post(
                '/management/get-list-leave-report-user',
                data
            );
            return response;
        } catch (error) {
            throw error;
        }
    }

    const getLeaveSummary = async (data) => {
        try {
            const response = await axiosConfig.post(
                '/management/leave/summary',
                data
            );
            return response;
        } catch (error) {
            throw error;
        }
    }

    const getLeaveUnpaid = async (data) => {
        try {
            const response = await axiosConfig.post(
                '/management/leave/unpaid',
                data
            );
            return response;
        } catch (error) {
            throw error;
        }
    }

    const updateLeaveTypesUser = async (data) => {
        try {
            const response = await axiosConfig.post(
                '/management/update-leave-types-user',
                data
            );
            return response;
        } catch (error) {
            throw error;
        }
    }

    return { getLeaveList, getLeaveCalendarEventList, addLeave, getLeaveTypeData, editLeave,
        deleteLeave, calendarLeave, addLeaveType, editLeaveType, deleteLeaveType, restoreLeaveType,
        getLeaveById, getPoliciesList, chartLeave, addLeaveRequest, getLeaveRequestList, deleteLeaveRequest,
        editLeaveRequest, updateLeaveRequestStatus, getLeaveRequestId, chartLeaveRequest, calendarLeaveRequest, 
        getLeaveRequestIdHistory, getLeaveSummaryUserList, getLeaveReportUserList, getLeaveSummary, getLeaveUnpaid, updateLeaveTypesUser
     }
}

export default LeaveApi
